import React, { useEffect, useState } from "react";
import TitleBar from "../../common/title-bar/title-bar";
import TableOptionsCell from "../../common/table/table-options-cell";
import Table from "../../common/table";
import APIService from "../../Service/APIService";
import "./DistributorCss.css";
import { useParams } from "react-router-dom";
import { useAuth } from "../AuthProvider.js";


const timeframeButtons = ["YTD", "MTD"];

const CommissionStatementsDistHome = (props) => {
  const { user, isReady } = useAuth();
  const userData = user;
  const { distributorData } = props;
  const { id } = useParams(); // distID
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [commissionStatements, setCommissionStatements] = useState([]);
  
  const [downloadLoadingStates, setDownloadingLoadingStates] = useState({});

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
  };

  const tableHeadersCommissionsStatements = [
    {
      headerName: "Month",
      field: "StatementMonthYear",
      filter: true,
    },
    {
      headerName: "Statement Start Date",
      field: "StatementStartDate",
      filter: true,
      cellRenderer: (params) => {
        return formatDate(params.data.StatementStartDate);
      },
    },
    {
      headerName: "Statement End Date",
      field: "StatementEndDate",
      filter: true,
      cellRenderer: (params) => {
        return formatDate(params.data.StatementEndDate);
      },
    },
    {
      headerName: "Total Comm. Applied",
      field: "TotalCommissionApplied",
      // filter: true,
      cellRenderer: (params) => {
        return `$${parseFloat(params.data.TotalCommissionApplied).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        })}`;
      },
    },
    {
      headerName: "Total Comm. Due",
      field: "TotalCommissionDue",
      // filter: true,
      cellRenderer: (params) => {
        return `$${parseFloat(params.data.TotalCommissionDue).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        })}`;
      },
    },
    {
      headerName: "Options",
      field: "",
      sortable: false,
      cellRenderer: (params) => (
        <TableOptionsCell
          optionDownloadButton="Download"
          optionDownloadButtonType="primary"
          optionDownloadButtonClickFn={async () => await downloadPDF(distributorData, params.data.ID, params.data)}
          optionDownloadButtonLoading={downloadLoadingStates[distributorData?.ID ?? distributorData?.DistributorID] || false}
          optionTwo="View"
          optionTwoType="warning"
          optionTwoClickPath={`/CommissionStatementsDistributor/${id}`}
          rowData={params.data}
          moreData={{ CommissionStatementID: params.data.ID, IsGenerated: params.data.IsGenerated }}
          type="CommissionStatementsDetails"
        />
      ),
    },
  ];

  const getData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend("getcommissionstatementsdisthome?DistributorID=" + id);
    console.log("getData", response.data.data);
    return response?.data?.data;
  }

  const downloadPDF = async (data, statementID, statement) => {
    setDownloadingLoadingStates(prev => ({ ...prev, [data?.DistributorID ?? data?.ID]: true }));
    try {
      const apiServe = new APIService();

      const response = await apiServe.getGeneratedFile(
        {
          statementID: statementID || null,
          // distID: data?.DistributorID || null,
          distID: id || null,
        },
        "generateCommissionPDFDist"
      );

      if (response) {
        // get the response as a blob
        const pdfBlob = await response.data;

        // check if the server sent a PDF. If not, log the error message inside the blob.
        if (pdfBlob.type !== 'application/pdf') {
          const errorText = await pdfBlob.text(); // Read the blob as text
          console.error('Server did not return a PDF. Response body:', errorText);
          alert('Failed to generate PDF. Check the console for server error message.');
          // setLoadingInvoices(prev => ({ ...prev, [invoiceId]: false }));
          return; // stop execution
        }

        // create a temporary URL for the blob
        const url = window.URL.createObjectURL(pdfBlob);

        // ceate a temporary link element to trigger the download
        const link = document.createElement('a');
        link.href = url;
        const stateMonthYearProcessed = statement.StatementMonthYear.replace(/ /g, '-');
        link.setAttribute('download', `${data?.DistributorName}-Commission-Statement-for-${stateMonthYearProcessed}.pdf`);
        document.body.appendChild(link);
        link.click();

        // clean up by removing the link and revoking the URL
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Failed to download PDF:", error);
    } finally {
      setDownloadingLoadingStates(prev => ({ ...prev, [data?.DistributorID ?? data?.ID]: false }));
    }
  };

  useEffect(() => {
    // Your code here
    console.log("DistributorData in CommissionStatementsDistHome:", distributorData);
    console.log("CommissionStatements.js");
    getData().then((data) => {
      if (data) {
        setCommissionStatements(data);
      }
    });
  }, []);


  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
      <Table
        rowData={commissionStatements}
        columnDefs={tableHeadersCommissionsStatements}
      />
    </div>
  );
};

export default CommissionStatementsDistHome;
